import React from 'react';
import { Drawer, Box, Typography, IconButton, Chip, Divider, CircularProgress, Link as MLink, List, ListItem, ListItemText } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

export default function HelpPanel({ open, onClose, data, loading, error, container }) {
  return (
    <Drawer 
      anchor="right" 
      open={open} 
      onClose={onClose} 
      container={container}
      ModalProps={{ 
        keepMounted: true,
        ...(container && { container, style: { position: 'absolute' } })
      }}
      PaperProps={{ sx: { width: 420, ...(container && { position: 'absolute' }) } }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', p: 2 }}>
        <Typography variant="h6" sx={{ mr: 1 }}>
          {data?.title ? `Help: ${data.title}` : 'Help'}
        </Typography>
        <IconButton aria-label="close" onClick={onClose} size="small">
          <CloseIcon fontSize="small" />
        </IconButton>
      </Box>
      <Divider />
      <Box sx={{ p: 2, display: 'flex', flexDirection: 'column', gap: 1.5 }}>
        {loading && (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <CircularProgress size={18} />
            <Typography variant="body2">Loading contextual help…</Typography>
          </Box>
        )}
        {error && (
          <Typography variant="body2" color="error">{String(error)}</Typography>
        )}
        {!loading && !error && data && (
          <>
            {data.summary && (
              <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap' }}>{data.summary}</Typography>
            )}
            {Array.isArray(data.bullets) && data.bullets.length > 0 && (
              <List dense sx={{ pt: 0 }}>
                {data.bullets.map((b, idx) => (
                  <ListItem key={idx} sx={{ py: 0 }}>
                    <ListItemText primaryTypographyProps={{ variant: 'body2' }} primary={`• ${b}`} />
                  </ListItem>
                ))}
              </List>
            )}
            {Array.isArray(data.citations) && data.citations.length > 0 && (
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, flexWrap: 'wrap' }}>
                {data.citations.map((c, i) => (
                  <Chip key={i} size="small" label={c.label || 'doc'} component="a" href={`file://${c.path}`} clickable />
                ))}
              </Box>
            )}
            {Array.isArray(data.related) && data.related.length > 0 && (
              <Box>
                <Divider sx={{ my: 1 }} />
                <Typography variant="caption" color="text.secondary">Related</Typography>
                <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'wrap', mt: 0.5 }}>
                  {data.related.map((r, i) => (
                    <Chip key={i} size="small" label={r.label} />
                  ))}
                </Box>
              </Box>
            )}
            {data.lowConfidence && Array.isArray(data.candidates) && data.candidates.length > 0 && (
              <Box>
                <Divider sx={{ my: 1 }} />
                <Typography variant="body2">Not confident enough. Possible topics:</Typography>
                <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'wrap', mt: 0.5 }}>
                  {data.candidates.map((c, i) => (
                    <Chip key={i} size="small" label={c.label} />
                  ))}
                </Box>
              </Box>
            )}
          </>
        )}
        {!loading && !error && !data && (
          <Typography variant="body2" color="text.secondary">No help available.</Typography>
        )}
      </Box>
    </Drawer>
  );
}


